import { FC, useCallback, useState } from 'react';

import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { SortingContext, SortingContextState } from 'utils/contexts/sorting/context';

const DEFAULT_SORT_FIELD = 'name';

type Props = {
  defaultSortField?: string;
  defaultSortDirection?: SORT_DIRECTIONS;
};

export const PanelSortingContextProvider: FC<React.PropsWithChildren<Props>> = ({
  children,
  defaultSortField = DEFAULT_SORT_FIELD,
  defaultSortDirection = SORT_DIRECTIONS.DESCENDING,
}) => {
  const [sortBy, setSortBy] = useState(defaultSortField);
  const [sortDirection, setActualSortDirection] = useState<SORT_DIRECTIONS>(defaultSortDirection);

  const setSortDirection = useCallback((dir: SORT_DIRECTIONS) => {
    const target =
      dir === SORT_DIRECTIONS.ASCENDING ? SORT_DIRECTIONS.ASCENDING : SORT_DIRECTIONS.DESCENDING;
    setActualSortDirection(target);
  }, []);

  const context: SortingContextState = {
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
  };

  return <SortingContext.Provider value={context}>{children}</SortingContext.Provider>;
};
